import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { XHRBackend, RequestOptions, Http } from '@angular/http';
import { Router } from "@angular/router";
import { tap } from 'rxjs/operators';
import 'rxjs/Rx';
import 'rxjs/add/operator/do';

declare var popupFunctionObject: any;

@Injectable()
export class HttpResponseInterceptorService extends Http {

  constructor(backend: XHRBackend, defaultOptions: RequestOptions, private router: Router, public _snackBar: MatSnackBar) {
    super(backend, defaultOptions);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        tap(event => {
          // 200 OK
        }, error => {
          var regEx500 = /^5[0-9][0-9]$/;
          var regEx400 = /^4[0-9][0-9]$/;

          if (error.status === 401 || error.status === 403) {
            console.log('The authentication session expires. Force refresh of the current page.');
            this.router.navigate(['/pages/auth/login']);
          }
          else if (error.status == 0) {
            this._snackBar.open("Something went wrong", 'OK', {
              duration: 2000
            });
          }
          else if (regEx500.test(error.status.toString())) {
            this._snackBar.open("500 - Internal Server Error", 'OK', {
              duration: 2000
            });
          }
          else if (regEx400.test(error.status.toString())) {
            this._snackBar.open("404 - Not Found", 'OK', {
              duration: 2000
            });
          }

          return Observable.throw(error);
        })
      );
  }
}
